import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalCacheManager } from '../../api/managers/local-cache.manager';
import { Constants } from '../../core/constants';

// NGRX
import { Store } from '@ngrx/store';
import { OverlayManagerService } from './../../services/overlay-manager.service';
import { AppState } from './../../store/reducers/index';
import { UserDetails } from './../store/auth.actions';

@Component({
    selector: 'app-welcome-page',
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.less'],
})
export class WelcomePageComponent implements OnInit {
    Constants = Constants;

    authState: Observable<any>;
    showLogin = false;
    showForgotPassword = false;
    userSignedOut = false;

    constructor(
        private localCacheManager: LocalCacheManager,
        private route: ActivatedRoute,
        private router: Router,
        private overlayManager: OverlayManagerService,
        private store: Store<AppState>) {
    }

    ngOnInit() {
        // LoginGuard may set this...
        this.overlayManager.hideProcessingOverlay.next(false);
        this.showLogin = this.route.snapshot.queryParams['signIn'] === 'true';
        this.userSignedOut = this.route.snapshot.queryParams['signout'] === 'true';
        if (this.userSignedOut) {
            this.router.navigate(['/']);
        }
        // Let's try to auto-login
        this.tryAutoLogin();
    }

    public getStarted() {
        this.router.navigate(['/register']);
    }

    public toggleLogin() {
        this.showLogin = !this.showLogin;
    }

    public toggleForgotPassword() {
        this.router.navigate(['login/forgot']);
    }

    public eatClick(e: Event) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
    }

    private tryAutoLogin() {
        if (this.localCacheManager.accessToken.length > 0) {
            this.store.dispatch(UserDetails());
        }
    }

}
